import React, { useState } from "react";
import {
    PiFacebookLogoDuotone,
    PiTwitterLogoDuotone,
    PiLinkedinLogoDuotone,
    PiWhatsappLogoDuotone,
    PiLinkDuotone,
} from "react-icons/pi";

const ShareLinks = ({ blogUrl, blogTitle }) => {
    const [copied, setCopied] = useState(false);

    // Trim URL to avoid spaces and encode for safe sharing
    const trimmedUrl = blogUrl.trim();
    const encodedUrl = encodeURIComponent(trimmedUrl);
    const encodedTitle = encodeURIComponent(blogTitle);

    // Share link generators
    const shareLinks = [
        {
            title: "Facebook",
            icon: <PiFacebookLogoDuotone size={24} />,
            url: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        },
        {
            title: "Twitter",
            icon: <PiTwitterLogoDuotone size={24} />,
            url: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        },
        {
            title: "LinkedIn",
            icon: <PiLinkedinLogoDuotone size={24} />,
            url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
        },
        {
            title: "WhatsApp",
            icon: <PiWhatsappLogoDuotone size={24} />,
            url: `https://api.whatsapp.com/send?text=${encodedUrl}%20`,
        },
    ];

    // Handle copy link to clipboard
    const handleCopyLink = () => {
        navigator.clipboard.writeText(trimmedUrl).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        });
    };

    return (
        <div className="flex lg:flex-col w-fit gap-2">
            {shareLinks.map((link, index) => (
                <a
                    key={index}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={`Share on ${link.title}`}
                    className="rounded-[32px] aspect-square flex items-center justify-center p-2 hover:bg-[var(--primary)] transition-all duration-300"
                    style={{
                        background:
                            "linear-gradient(149.54deg, rgba(211, 211, 211, 0.2) 22.72%, rgba(255, 255, 255, 0.4) 115.21%)",
                    }}
                >
                    {link.icon}
                </a>
            ))}
            <button
                onClick={handleCopyLink}
                title="Copy Link"
                className="rounded-[32px] aspect-square flex items-center justify-center p-2 hover:bg-[var(--primary)] transition-all duration-300"
                style={{
                    background: copied
                        ? "var(--primary)"
                        : "linear-gradient(149.54deg, rgba(211, 211, 211, 0.2) 22.72%, rgba(255, 255, 255, 0.4) 115.21%)",
                }}
            >
                <PiLinkDuotone size={24} />
            </button>
        </div>
    );
};

export default ShareLinks;